import React from 'react';
import GeoAI from './GeoAI';
import Assets from './Assets';
import Capture from './Capture';
import Workspace from './Workspace';
import styled from 'styled-components';
import Marketplace from './Marketplace';
import Layout from '../../../Layout/index';
import { paddingLeft } from '@/utils/directions';
import { Route, Redirect } from 'react-router-dom';
import { colorBackgroundBody } from '@/utils/palette';
import AppDashboard from '@/containers/Dashboards/App';

export default () => (
  <div>
    <Layout />
    <ContainerWrap>
      <Redirect exact from="/" to="dashboard" />
      <Route path="/dashboard" component={AppDashboard} />
      <Route path="/workspace" component={Workspace} />
      <Route path="/marketplace" component={Marketplace} />
      <Route path="/capture" component={Capture} />
      <Route path="/assets" component={Assets} />
      <Route path="/geoai" component={GeoAI} />
    </ContainerWrap>
  </div>
);

// region STYLES

const ContainerWrap = styled.div`
  padding-top: 90px;
  min-height: 100vh;
  transition: padding-left 0.3s;

  ${paddingLeft}: 0;

  background: ${colorBackgroundBody};

  @media screen and (min-width: 576px) {
    ${paddingLeft}: 250px;
  }

  @media screen and (max-width: 576px) {
    padding-top: 150px;
  }
`;

// endregion
